import { Component, OnInit, OnDestroy, Inject, ViewChild, Output, EventEmitter } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { DefaultValuesService } from '../../../../services/defaultvalues.service';
import { Utils } from '../../../../utils/utils';
import { Subscription } from "rxjs";
import { ContractBundleListComponent } from "./contractbundlelist.component";
import { ContractBundleListService } from "./contractbundlelist.service";

@Component({
    selector: "contractbundle",
    templateUrl: 'contractbundle.component.html',
    styleUrls: [],
    standalone: false
})

export class ContractBundleComponent implements OnInit, OnDestroy {

    list: any[] = [];
    contractBundleOptions: any[] = [];
    translations: ContractBundleLocalTranslation[] = [];

    showLocalFilter = false;

    subscriptionTenant: any;
    subscriptions: Subscription[] = [];

    @ViewChild(ContractBundleListComponent, { static: true }) listComponent!: ContractBundleListComponent;

    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string, private readonly defaults: DefaultValuesService,
        private readonly contractBundleListService: ContractBundleListService) { }

    ngOnInit(): void {
        this.subscriptionTenant = this.defaults.tenantMessageChanges$.subscribe(() => {
            this.getContractBundlesByTenant()
        });
        if (this.defaults.tenant) {
            this.getContractBundlesByTenant()
            this.getContractBundleOptionsByTenant()
        }
    }


    ngOnDestroy() {
        this.subscriptions.forEach(x => x.unsubscribe())
        this.subscriptionTenant.unsubscribe();
    }

    getContractBundlesByTenant() {
        Utils.httpGetContractBundleInformation(
            this.http
            , this.baseUrl
            , this
            , function (tthis: ContractBundleComponent, list: ContractBundle[]) {
                tthis.getAllLocalTranslationsAndMerge(list);
            }
        );
    }

    getAllLocalTranslationsAndMerge(list: ContractBundle[]) {
        this.contractBundleListService.getContractBundleTranslations().subscribe({
            next: (translations) => {
                this.translations = translations;
                this.mergeData(list, translations);
            },
            error: (error) => {
                console.error('Error fetching contract bundle translations:', error);
            }
        });
    }

    mergeData(list: ContractBundle[], translations: ContractBundleLocalTranslation[]) {
        const grouped = {};
        list.forEach((e) => {
            if (!grouped[e.Bundle]) {
                grouped[e.Bundle] = [];
            }
            const translation = translations.find(
                t => t.BundleId === e.BundleId && t.FeatureId === e.FeatureId
            );
            grouped[e.Bundle].push({
                Feature: e.Feature,
                FeatureId: e.FeatureId,
                BundleId: e.BundleId,
                LocalContractLine: translation ? translation.LocalContractLine : ''
            });
        });

        const result = Object.keys(grouped).map((bundle) => ({
            Bundle: bundle,
            BundleId: list.find(x => x.Bundle === bundle)?.BundleId || 0,
            BundleList: grouped[bundle]
        }));
        this.list = result;
    }

    getContractBundleOptionsByTenant() {
        Utils.httpGetContractBundleOptions(
            this.http
            , this.baseUrl
            , this
            , function (tthis: any, list: ContractBundle[]) {
                const grouped = {};
                list.forEach((e) => {
                    if (!grouped[e.Bundle]) {
                        grouped[e.Bundle] = [];
                    }
                    grouped[e.Bundle].push(e.Feature);
                });

                const result = Object.keys(grouped).map((bundle) => ({ Bundle: bundle, BundleId: list.filter(x => x.Bundle === bundle)[0].BundleId, BundleList: grouped[bundle] }));
                tthis.contractBundleOptions = result
            }
        );
    }

    onReload() {
        this.getContractBundlesByTenant();
    }
}
